import {
	Modal,
	MimaText,
	MimaButton,
	MimaInput,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Inventory/Inventory.module.scss';
import { Field, FieldArray, Formik } from 'formik';
import React, { useRef } from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldDropdown = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const AddRateCard = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
}) => {

	const ref = useRef();

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Add Multiple Rate Cards
			</MimaText>
			<Formik
				innerRef={ref}
				initialValues={{
					rateCards: [
						{
							title: '',
							grade: '',
							sellingPrice: 0,
							splitPercentage: 0,
						},
					],

				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleSubmit,
					values,
					errors,
					touched,
					setFieldValue,
				}) => (
					<div>
						<FieldArray name="rateCards">
							{({ push, remove }) => (
								<React.Fragment>
									{values.rateCards.map((_, i) => (
										<div key={i}>
											<Field
												type="text"
												mt={2}
												name={`rateCards.${i}.grade`}
												id={`rateCards.${i}.grade`}
												value={values.rateCards[i].grade}
												component={FieldDropdown}
												labelTitle="Grade"
												placeholder="Grade"
												touched={touched?.rateCards?.[i]?.grade}
												error={errors?.rateCards?.[i]?.grade}
												data={[
													{
														value: 'STANDARD',
														key: 'STANDARD',
													},
													{
														value: 'BUDDING',
														key: 'BUDDING',
													},
													{
														value: 'PREMIUM',
														key: 'PREMIUM',
													},
													{
														value: 'TOP',
														key: 'TOP',
													},
													{
														value: 'EXCEPTIONAL',
														key: 'EXCEPTIONAL',
													},

												]}
												onChange={data => {
													setFieldValue(`rateCards.${i}.grade`, data.value);
												}}
											/>
											<Field
												name={`rateCards.${i}.title`}
												id={`rateCards.${i}.title`}
												component={FieldInput}
												type="text"
												labelTitle="Title"
												mt={2}
												touched={touched?.rateCards?.[i]?.title}
												error={errors?.rateCards?.[i]?.title}
											/>

											<Field
												name={`rateCards.${i}.sellingPrice`}
												id={`rateCards.${i}.sellingPrice`}
												component={FieldInput}
												type="number"
												labelTitle="Selling Price"
												mt={2}
												touched={touched?.rateCards?.[i]?.sellingPrice}
												error={errors?.rateCards?.[i]?.sellingPrice}
											/>

											<Field
												name={`rateCards.${i}.splitPercentage`}
												id={`rateCards.${i}.splitPercentage`}
												component={FieldInput}
												type="number"
												labelTitle="Split Percentage"
												mt={2}
												touched={touched?.rateCards?.[i]?.splitPercentage}
												error={errors?.rateCards?.[i]?.splitPercentage}
											/>
											{i !== 0 ? (
												<MimaButton
													title="Remove"
													variant="filter"
													type="button"
													buttonColor="var(--color-error)"
													width={10}
													onClick={() => remove(i)}
												/>
											) : (
												''
											)}
											<div className={styles.summary__line}></div>
										</div>
									))}
									<MimaButton
										title="Add Another Rate Card"
										variant="text"
										type="button"
										onClick={() =>
											push({
												sellingPrice: 0,
												splitPercentage: 0,
												grade: '',
												title: '',
											})
										}
										width={38}
									/>
								</React.Fragment>
							)}
						</FieldArray>

						<MimaButton
							title="Continue"
							type="submit"
							onClick={handleSubmit}
							loading={loading}
							mt={2}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default AddRateCard;